// extracted by mini-css-extract-plugin
export var avatarContainer = "_99-0";
export var avatarTypingWave = "_99-i";
export var gray = "_99-f";
export var green = "_99-c";
export var icon = "_99-9";
export var image = "_99-1";
export var lg = "_99-6";
export var md = "_99-5";
export var presenceDot = "_99-b";
export var red = "_99-d";
export var sm = "_99-4";
export var status = "_99-a";
export var typingDot = "_99-h";
export var typingPill = "_99-g";
export var xl = "_99-7";
export var xs = "_99-3";
export var xxl = "_99-8";
export var xxs = "_99-2";
export var yellow = "_99-e";